import {
    GET_WORKKARD_SEARCH_LIST_REQUEST,
    FETCH_USER_RECENT_SEARCHES_REQUEST,
    REMOVE_RECENT_SEARCH_ITEM_REQUEST,
    RESET_SEARCH_SUGGESTIONS_REQUEST,
    CHANGE_ACTIVE_TAB,
    FETCH_SEARCH_RESULT_DATA_REQUEST,
    FETCH_ACTIVITY_SEARCH_RESULT_DATA_REQUEST,
    FETCH_NOTES_SEARCH_RESULT_DATA_REQUEST,
    FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_REQUEST,
    FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_REQUEST,
    FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_REQUEST,
    FETCH_FILES_SEARCH_RESULT_DATA_REQUEST,
    ADD_GLOBAL_SEARCH_USAGE_REQUEST,
    RESET_GLOBAL_SEARCH,
    GET_TOPBAR_TABS_COUNT,
    SAVE_SEARCH_STRING_REQUEST,
    RESET_INDIVIDUAL_GLOBAL_SEARCH
} from './actionConstants';

export const getWorkkardSearchList = (payload) => ({
    type: GET_WORKKARD_SEARCH_LIST_REQUEST,
    payload
})

export const fetchUserRecentSearches = (payload) => ({
    type:FETCH_USER_RECENT_SEARCHES_REQUEST,
    payload
});

export const removeRecentSearchItem = (payload) => ({
    type:REMOVE_RECENT_SEARCH_ITEM_REQUEST,
    payload
})

export const resetSearchSuggestion = (payload) => ({
    type:RESET_SEARCH_SUGGESTIONS_REQUEST
})

export const changeActiveTab = (payload) => ({
    type:CHANGE_ACTIVE_TAB,
    payload
});

export const fetchSearchResultData =(payload) =>({
    type:FETCH_SEARCH_RESULT_DATA_REQUEST,
    payload
})


export const fetchActivitySearchResultData =(payload) =>({
    type:FETCH_ACTIVITY_SEARCH_RESULT_DATA_REQUEST,
    payload
})

export const fetchNotesSearchResultData=(payload)=>({
    type:FETCH_NOTES_SEARCH_RESULT_DATA_REQUEST,
    payload
})

export const fetchFilesSearchResultData=(payload)=>({
    type:FETCH_FILES_SEARCH_RESULT_DATA_REQUEST,
    payload
})

export const fetchActivityOwnerSearchResultData =(payload) =>({
    type:FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_REQUEST,
    payload
})

export const fetchActivityAssigneeSearchResultData =(payload) =>({
    type:FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_REQUEST,
    payload
})

export const fetchWorkkardOwnerSearchResultData=(payload)=>({
    type:FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_REQUEST,
    payload
})

export const addglobalsearchusage=(payload)=>({
    type:ADD_GLOBAL_SEARCH_USAGE_REQUEST,
    payload
})

export const resetGlobalSearch=()=>({
    type:RESET_GLOBAL_SEARCH
});

export const resetIndividualTabGlobalSearch = (payload) =>({
    type:RESET_INDIVIDUAL_GLOBAL_SEARCH,
    payload
})

export const getTopbarTabsCount = (payload) => ({
    type: GET_TOPBAR_TABS_COUNT,
    payload
})

export const saveSearchString = (payload) => ({
    type:SAVE_SEARCH_STRING_REQUEST,
    payload
})